export const STYLE_MAP = {
  default: {
    borderRadius: '32px'
  },
  diablo: {
    borderRadius: '32px'
  },
  colmo: {
    borderRadius: '16px'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-card/style.js